import _asyncToGenerator from "/portal/Vue/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/portal/Vue/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.object.to-string.js";
import axios from 'axios';
// import https from 'https';

if (!Comment.prototype.contains) Comment.prototype.contains = function () {
  return false;
};

// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function value(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}

// Удаление элемента из массива.
// String value: значение, которое необходимо найти и удалить.
// return: массив без удаленного элемента; false в противном случае.

Array.prototype.remove = function (value) {
  var idx = this.indexOf(value);
  if (idx != -1) {
    return this.splice(idx, 1);
  }
};
if (typeof Array.isArray === 'undefined') {
  Array.isArray = function (obj) {
    return Object.prototype.toString.call(obj) === '[object Array]';
  };
}
export var axiosInst = axios.create({
  // baseURL: 'https://smartplatform.herokuapp.com',
  // baseURL: 'http://localhost:5000',
  baseURL: window.smartConfig.BACKEND_URL,
  timeout: 300000,
  // httpsAgent: new https.Agent({
  //   rejectUnauthorized: false
  // }),
  withCredentials: true
});
axiosInst.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.request.status === 401) {
    // 401-ая ошибка означает, что нет аутентификации, отправим на форму логина
    window.location.hash = '/login';
    return;
  }
  throw error;
});
export default (/*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var Vue;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          Vue = _ref.Vue;
          Vue.prototype.$axios = axiosInst;
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}());